export const MODAL_QUOTES_SHOW = "MODAL_QUOTES_SHOW";
export const MODAL_QUOTES_HIDE = "MODAL_QUOTES_HIDE";

const initialState = {
  openModal: false
};

export default function modalQuotesReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MODAL_QUOTES_SHOW:
      return payload;

    case MODAL_QUOTES_HIDE:
      return payload;

    default:
      return state;
  }
}

export function showQuoteModal() {
  return {
    type: MODAL_QUOTES_SHOW,
    payload: {
      openModal: true
    }
  };
}

export function hideQuoteModal() {
  return {
    type: MODAL_QUOTES_HIDE,
    payload: {
      openModal: false
    }
  };
}
